import { signInWithGoogle } from '../lib/session';

export default function SignIn() {
  return (
    <div className="gate">
      <div className="mark">Couch&nbsp;Backstage</div>
      <p className="lede">
        Behind the scenes of Couch Questions. Sign in to check translations in the languages
        you speak, and to get credit for the ones you fix.
      </p>

      <div className="reassure" style={{ margin: '0 0 24px' }}>
        <span style={{ color: 'var(--ok)', fontWeight: 800 }}>✓</span>
        <span>
          <span className="t">Nothing you do goes live on its own</span>
          <span className="d">
            You collect changes into a batch, look the whole thing over, and send it when you are
            ready. Sam reviews every batch before any of it reaches the app.
          </span>
        </span>
      </div>

      <button className="btn pri" onClick={() => void signInWithGoogle()}>
        Continue with Google
      </button>

      <p className="hint" style={{ marginTop: 16 }}>
        New here? Signing in requests access — you will see everything once Sam approves you.
      </p>
    </div>
  );
}
